module.exports = __webpack_public_path__ + "static/logo-34e992e323cb9ae64d6ad211ad56b9c0.png";